export var getLocalePrefix = function () {
    var _a;
    var locale = document.documentElement.dataset.marketLocale;
    var langInPath = (_a = document.documentElement.dataset.langInPath) !== null && _a !== void 0 ? _a : false;
    if (langInPath && langInPath === 'true' &&
        locale !== 'en-us' &&
        locale !== 'en') {
        return "/" + locale;
    }
    return '';
};
